import { addSharingLink, addSharingLinkToContianer, sharingLinkRemoved } from 'owa-link-data';
import { mutator } from 'satcheljs';

// TODO vso 33492 mutator should not take in object it is mutating. Due to current limitations of attachmentWell this is currently unavoidable.
mutator(addSharingLink, actionMessage => {
    addLink(actionMessage.sharingLinkIds, actionMessage.linkId);
});

mutator(sharingLinkRemoved, actionMessage => {
    removeLink(actionMessage.sharingLinkIds, actionMessage.linkId);
});

mutator(addSharingLinkToContianer, actionMessage => {
    addLink(actionMessage.linkIdContainer, actionMessage.linkId);
});

export function removeLink(sharingLinkIds: string[], linkId: string) {
    const index = sharingLinkIds.indexOf(linkId);
    if (index !== -1) {
        sharingLinkIds.splice(index, 1);
    }
}

export function addLink(sharingLinkIds: string[], linkId: string) {
    if (linkId && !sharingLinkIds.includes(linkId)) {
        sharingLinkIds.push(linkId);
    }
}
